import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "./Home";
import Normal from "./Normal";
import Advance from "./Advance";
import Name from "./Name";
import NotFound from "../NotFound";
const Search = ({ match, updateHeader, updateBreadcrumb }) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/normal`}
        exact
        render={props => (
          <Normal
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/advance`}
        exact
        render={props => (
          <Advance
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/name`}
        exact
        render={props => (
          <Name
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />

      <Route
        path={`${match.url}`}
        exact
        render={props => (
          <Home
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        render={props => (
          <NotFound
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
    </Switch>
  );
};

export default Search;



// WEBPACK FOOTER //
// ./src/_components/Search/index.js